import api from './apiRequester'

// Fetch a generated file URL and trigger a download via a blob anchor rather
// than window.open. iOS Safari blocks window.open() that runs after an await
// (it's no longer a direct user gesture), which silently fails the download even
// though the request succeeded. A same-origin blob URL with a download attribute
// works reliably across desktop and mobile.
export const triggerBlobDownload = async (fileUrl: string, filename: string) => {
    const csvText = await fetch(fileUrl).then((r) => r.text())
    const blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' })
    const blobUrl = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = blobUrl
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(blobUrl)
}

// Request a CSV report (backend returns { fileUrl }) and download it. Returns the
// raw response data so callers can read rowCount etc.
export const downloadCsvReport = async (endpoint: string, body: any, filename: string) => {
    const response = await api({ url: endpoint, data: body })
    const fileUrl = response.data?.fileUrl
    if (!fileUrl) throw new Error('No file URL received from server')
    await triggerBlobDownload(fileUrl, filename)
    return response.data
}
